import { action, asyncAction } from 'lib/actions';

export const setSelectedPlanTypeAction = action('upgradeSubscriptionPage/SET_SELECTED_PLANTYPE');
export const fetchPlanTypesAction = asyncAction('upgradeSubscriptionPage/FETCH_PLAN_TYPES');
export const upgradePlanAction = asyncAction('upgradeSubscriptionPage/UPGRADE_PLAN');
